export default "__VITE_ASSET__cadd0914__"